import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'utcDate'
})
export class UtcDatePipe implements PipeTransform {

    transform(value: string): any {

        if (!value) {
            return '';
        }

        const dateValue = new Date(value);
        const timezoneOffset = dateValue.getTimezoneOffset() * 60 * 1000;
        const utcTime = dateValue.getTime();
        const localTime = utcTime - timezoneOffset;

        return new Date(localTime);
    }
}
